import React from "react";
import NavSubItem, { NavSubItemWithPermission } from "../Sidebar/NavSubItem";
import SidebarSubmenu from "../Sidebar/SidebarSubmenu";
import IconEventLogTable from "../../Icons/Report/EventLog";
import IconLicensing from "../../Icons/SideMenu/Licensing";
// import IconHelp from "../../Icons/SideMenu/Help";
// import IconRefImgAnalysis from "../../Icons/Report/RefPlate";
// import IconSendFeedback from "../../Icons/SideMenu/SendFeedback";
// import IconRecoverFile from "../../Icons/SideMenu/RecoverFile";
import IconUserManagement from "../../Icons/SideMenu/UserManagement";
import { EComponentId } from "../../Model/Permission";

const ReportAndSupportNavSubMenu = () => {
  return (
    <SidebarSubmenu>
      <NavSubItemWithPermission
        label="Event Log Table"
        key="eventLog"
        to="/report-support/event-log"
        icon={<IconEventLogTable />}
        componentId={EComponentId.ReportAndSupportEventLog}
      />
      {/* <NavSubItem label="Send File" key="supporttools" to="/report-support/support-tools" icon={<IconSendFeedback />} />
      <NavSubItem label="Recover" key="recover" to="/report-support/recover" icon={<IconRecoverFile />} /> */}
      <NavSubItemWithPermission
        label="Licensing"
        key="licensing"
        to="/report-support/licensing"
        icon={<IconLicensing />}
        componentId={EComponentId.ReportAndSupportLicensing}
      />
      {/* <NavSubItem label="Help" key="help" to="/report-support/help" icon={<IconLicensing />} /> */}
      <NavSubItemWithPermission
        label="User Mgmt"
        key="user"
        to="/report-support/user-management"
        icon={<IconUserManagement />}
        componentId={EComponentId.ReportAndSupportUserManagement}
      />

      {/* <NavSubItem
        label="Ref. Plate Img. Analysis"
        key="eventLog"
        to="/report-support/ref-plate"
        icon={<IconRefImgAnalysis />}
      /> */}
    </SidebarSubmenu>
  );
};

export default ReportAndSupportNavSubMenu;
